/**
 * User: WangMeng
 * Date: 2018-07-16
 * Time: 9:17
 * Desc: 财务隐患提示
 */
import styles from './danger.scss';
import React, { PureComponent } from 'react';
import { Spin } from 'antd';
import { createRandom, isNotEmpty } from '../../../../../utils/util';
import { calcSymbolSize } from '../../../../../utils/chart';
import { wordLinefeed } from '../../../../../utils/formatter';
import NoData from '../../../../common/noData/NoData';
import BBDAxisScatter from '../../../../common/echarts/BBDAxisScatter';
import { commonRequest } from '../../../common/commons';
import { queryRiskDanger } from '../../../../../services/financialPicture/overview';

export default class Danger extends PureComponent{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            scatterOption: {}
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.setState({
            loading: true
        });

        queryRiskDanger(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                loading: false,
                scatterOption: this.formatData(data)
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    formatData = (data) => {
        let { companyName, list } = data;
        list = list || [];
        let middle = Math.ceil(list.length / 2);

        list.forEach((d, i) => {
            i = i < middle ? i : i + 1;
            d.nameLength = d.exName.length;
            d.name = d.exName;
            d.value = [i, i % 2 === 0 ? createRandom(0.5, 2.5) : createRandom(7.5, 9)];
            d.itemStyle = {
                opacity: 1
            };
        });
        calcSymbolSize(list, 'nameLength', [60, 90]);

        if(middle === 0) { // 没有数据的时候
            list.push({
                name: 'left',
                symbolSize: 0,
                value: [0, 0]
            });
            middle = 1;
        }
        if(list.length % 2 !== 0) { // 保证数组是偶数才能均匀分布
            list.push({
                name: 'right',
                symbolSize: 0,
                value: [middle * 2, 10]
            });
        }

        // 添加公司数据
        let company = {
            name: companyName,
            value: [middle, 5],
            symbolSize: 100,
            label: {
                fontSize: 16
            },
            itemStyle: {
                color: '#73CDFC',
                opacity: 1
            },
            tooltip: {
                show: false
            }
        };
        list.splice(middle, 0, company);

        return {
            color: ['#5F9AF0', '#2365C4', '#FBBE91', '#F99248', '#5F9AF0'],
            grid: {
                top: 50,
                left: '20%',
                right: '20%',
                bottom: 50
            },
            xAxis: {
                show: false
            },
            yAxis: {
                show: false,
                max: 10
            },
            tooltip: {
                formatter: function (param) {
                    return wordLinefeed(param.data.explain, 16, '<br />');
                }
            },
            label: {
                show: true,
                formatter: function (data) {
                    return wordLinefeed(data.name, 4);
                },
                textBorderColor: 'transparent'
            },
            data: list.map(d => ({ data: [d] }))
        };
    };

    render() {
        const { loading, scatterOption } = this.state;

        return (
            <div className={styles.scatterChart}>
                {
                    loading ?
                        <Spin /> :
                        isNotEmpty(scatterOption) ?
                            <BBDAxisScatter option={scatterOption}/> : <NoData />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/overview/subComponents/risk/Danger.jsx